

const credentials = Object.freeze({
    firebaseConfig : {
        apiKey: "AIzaSyCNiK1eKDIzmbZ9H4NsRxrUQsfGwWKfU8I",
        authDomain: "virtual-sum-307700.firebaseapp.com",
        databaseURL: "https://virtual-sum-307700-default-rtdb.firebaseio.com",
        projectId: "virtual-sum-307700",
        storageBucket: "virtual-sum-307700.appspot.com",
        messagingSenderId: "570430561657",
        appId: "1:570430561657:web:039793ba66a34a6a3ee3a8",
        measurementId: "G-D3C5LENXLV"
    }

})

export default  credentials;
